/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductImageZoomDialogComponent } from '@spartacus/product/image-zoom/components';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { CustomProductImageZoomViewComponent } from '../product-image-zoom-view/product-image-zoom-view.component';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'cx-product-image-zoom-dialog',
  templateUrl: 'product-image-zoom-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconModule, KeyboardFocusModule, CustomProductImageZoomViewComponent, I18nModule],
})
export class CustomProductImageZoomDialogComponent extends ProductImageZoomDialogComponent {}
